import { SVGProps } from '@components/Icon/types';

export const Export = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(4, 2)">
      <path
        d="M7.62432 8.46768C7.87679 8.30461 8.22057 8.33192 8.44283 8.54936L10.7377 10.7955C10.9917 11.0439 10.9916 11.4471 10.7377 11.6957C10.4838 11.9437 10.0724 11.9438 9.81851 11.6957L8.63339 10.5362V15.3631C8.63339 15.7145 8.34185 15.9995 7.98276 15.9996C7.62352 15.9996 7.33212 15.7146 7.33212 15.3631V10.5362L6.14701 11.6957C5.89302 11.9441 5.48086 11.9441 5.22686 11.6957C4.97287 11.4472 4.97293 11.044 5.22686 10.7955L7.52269 8.54936L7.62432 8.46768Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.36116 0C9.91155 0 10.4403 0.213532 10.8294 0.594815L15.8258 5.48295C15.9089 5.56436 15.9653 5.66838 15.9882 5.78125C15.9923 5.80127 15.9981 5.89847 16 5.91886V17.4858C16 18.8684 14.8434 20 13.4301 20H2.56987C1.15663 20 0 18.8684 0 17.4858V2.5142C0 1.13158 1.15663 0 2.56987 0H9.36116ZM2.56987 1.16388C1.80209 1.16388 1.18966 1.76305 1.18966 2.5142V17.4858C1.18966 18.237 1.80209 18.8361 2.56987 18.8361H13.4301C14.1979 18.8361 14.8103 18.237 14.8103 17.4858V8.21822L14.8058 6.47639H11.4555C10.8493 6.47634 10.3007 6.21768 9.92015 5.80788C9.58499 5.44683 9.38028 4.96848 9.38022 4.44602V1.17809L9.37205 1.17276L9.36842 1.17099C9.362 1.16713 9.35788 1.16498 9.35572 1.16388H2.56987ZM10.5699 4.44602C10.57 4.9305 10.9603 5.31241 11.4555 5.3125H13.9691L10.5699 1.98686V4.44602ZM0.101633 2.5506V2.54705L0 2.5142L0.101633 2.5506Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'export';
